// extracted by mini-css-extract-plugin
export default {"content":"sL-z","lookName":"tL-z","shopTheLookContainer":"uL-z","productContainer":"vL-z","imageContainer":"wL-z","mainImage":"xL-z"};